import { render, staticRenderFns } from "./PieChartGridWidget.vue?vue&type=template&id=c02c42c2&scoped=true&"
import script from "./PieChartGridWidget.vue?vue&type=script&lang=ts&"
export * from "./PieChartGridWidget.vue?vue&type=script&lang=ts&"
import style0 from "./PieChartGridWidget.vue?vue&type=style&index=0&id=c02c42c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02c42c2",
  null
  
)

export default component.exports